module.exports = __webpack_public_path__ + "static/redSquiggle-7ef898d4e9b136ac4647ec30835b4cc8.png";